module.exports = __webpack_public_path__ + "static/media/route-treasure.26a7bf90.png";